// package: cbv1
// file: proto/vorto/dialog/dialog_api.proto

var proto_vorto_dialog_dialog_api_pb = require("../../../proto/vorto/dialog/dialog_api_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var DialogService = (function () {
  function DialogService() {}
  DialogService.serviceName = "cbv1.DialogService";
  return DialogService;
}());

DialogService.clientMessage = {
  methodName: "clientMessage",
  service: DialogService,
  requestStream: false,
  responseStream: false,
  requestType: proto_vorto_dialog_dialog_api_pb.ClientMessageRequest,
  responseType: proto_vorto_dialog_dialog_api_pb.ClientMessageResponse
};

exports.DialogService = DialogService;

function DialogServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

DialogServiceClient.prototype.clientMessage = function clientMessage(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(DialogService.clientMessage, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.DialogServiceClient = DialogServiceClient;

